import { PageLoading } from 'embroil/components/loading';

<template>
  <PageLoading @message="Loading latest news..." @subtitle="Getting the freshest gaming news and updates" />
</template>
